<template>
  <FormStepper
    v-if="!showResults"
    :valid-step="1"
    header-teleport-target="#modal-header"
    wizard-title="Funkcheck"
    @on-tab-change="goToPreviousForm"
    @on-stepper-completion="showFunkcheckResults"
  >
    <StepperContent icon="mdi-plus"></StepperContent>

    <StepperContent icon="mdi-signal" :selected="true">
      <MobileSignalStrength />
    </StepperContent>

    <StepperContent icon="mdi-link">
      <QAppStep />
    </StepperContent>

    <StepperContent icon="mdi-cloud-arrow-up-outline">
      <SendReceiveStep />
    </StepperContent>

    <StepperContent icon="mdi-hammer">
      <GatewayInstallationStep />
    </StepperContent>

    <StepperContent icon="mdi-signal-variant">
      <ScanFunctionStep />
    </StepperContent>
  </FormStepper>

  <div v-if="showResults" class="h-full flex flex-col justify-between">
    <DeviceManagement class="flex-[0.8]" />
    <div class="column is-6 flex-[0.2]">
      <PrimaryButton
        class="button is-wide is-primary"
        data-testid="funkcheck-restart"
        label="Funkcheck neu starten"
        @click="restartFunkcheck()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import FormStepper from '@/components/UI/Stepper/FormStepper.vue';
import StepperContent from '@/components/UI/Stepper/StepperContent.vue';
import MobileSignalStrength from '@/components/Funkcheck/MobileSignalStrength.vue';
import QAppStep from '@/components/Funkcheck/QAppStep.vue';
import SendReceiveStep from '@/components/Funkcheck/SendReceiveStep.vue';
import GatewayInstallationStep from '@/components/Funkcheck/GatewayInstallationStep.vue';
import ScanFunctionStep from '@/components/Funkcheck/ScanFunctionStep.vue';
import DeviceManagement from '@/components/Funkcheck/DeviceManagement.vue';
import { ref } from 'vue';
import { useFormStore } from '@/store/form/formStore';
import PrimaryButton from '@/components/UI/Button/PrimaryButton.vue';

const formStore = useFormStore();
const showResults = ref(false);

const goToPreviousForm = (index: number): void => {
  if (index === 0) {
    formStore.setToLastForm();
  }
};

const restartFunkcheck = (): void => {
  showResults.value = false;
};

const showFunkcheckResults = (): void => {
  showResults.value = true;
};
</script>

<style lang="scss"></style>
